import Swiper from "swiper"
import { find } from "utils/dom"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	console.log('Page home');

const swiperWork = new Swiper(".swiper-work", {
  slidesPerView: "auto",
  spaceBetween: 16,
  direction: "horizontal",
  pagination: {
    el: ".swiper-pagination-work",
    clickable: true,
  }
});

const swiperSocialMedia = new Swiper(".swiper-social-media", {
     slidesPerView: 'auto',
     spaceBetween: 80,
     loop:true,
     freeMode: true,
     autoplay: {
       delay: 2000,
       disableOnInteraction: false,
     },
});

const swiperBets = new Swiper(".swiper-bets", {
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      loop:true,
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: true,
      },
      pagination: {
        el: ".swiper-pagination-bets",
      },
});

const slidesMedia = document.querySelectorAll(".swiper-social-media .btn-play-media.btn-play") 
slidesMedia.forEach(btn => {
  const slide = btn.closest(".swiper-slide");
  const video = slide.querySelector("video");

  if (video) {
    video.addEventListener("play", () => {
      swiperSocialMedia.autoplay.stop();
    });

    video.addEventListener("pause", () => {
      swiperSocialMedia.autoplay.start();
    });

    video.addEventListener("ended", () => {
      swiperSocialMedia.autoplay.start();
    });
  }
})

function initVideoControls() {
  const videos = document.querySelectorAll('.swiper-slide video');
  console.log('Vídeos encontrados:', videos.length);

  videos.forEach(video => {
    const slide = video.closest('.swiper-slide');
    const btnPlay = slide.querySelector('.btn-play-media.btn-play');

    if (!btnPlay) return;

    // Clique no botão play ou pause → alterna
    btnPlay.addEventListener('click', e => {
      e.stopPropagation();

      // Pausar outros vídeos
      videos.forEach(v => {
        if (v !== video) v.pause();
      });

      // Alternar play/pause
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });

    // Quando o vídeo começa a tocar
    video.addEventListener('play', () => {
      btnPlay.style.display = 'none';
    });

    // Quando o vídeo é pausado
    video.addEventListener('pause', () => {
      btnPlay.style.display = 'block';
    });
  });
}

function initVideoControlsCpi() {
  const videos = document.querySelectorAll('.video-cpi video');
  console.log('Vídeos encontrados:', videos.length);

  videos.forEach(video => {
    const slide = video.closest('.video-cpi');
    const btnPlay = slide.querySelector('.btn-play-media.btn-play');

    if (!btnPlay) return;

      btnPlay.addEventListener('click', e => {
        e.stopPropagation();
        // Alternar play/pause
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });

    // Quando o vídeo começa a tocar
    video.addEventListener('play', () => {
      btnPlay.style.display = 'none';
    });

    // Quando o vídeo é pausado
    video.addEventListener('pause', () => {
      btnPlay.style.display = 'block';
    });
  });
}

window.addEventListener('load', () => {
  setTimeout(initVideoControls, 300); // garante que Swiper e DOM estejam prontos
  setTimeout(initVideoControlsCpi, 300); // garante que Swiper e DOM estejam prontos
});

}